export const parseDateTime = (dateTimeString) => {
    if (!dateTimeString) return { date: '', time: '' };
  
    try {
      const date = new Date(dateTimeString);
      if (isNaN(date)) throw new Error('Invalid date');
  
      const formattedDate = date.toISOString().slice(0, 10);
      const formattedTime = date.toTimeString().slice(0, 5);
  
      return { date: formattedDate, time: formattedTime };
    } catch (e) {
      console.error('Error parsing date:', dateTimeString, e);
      return { date: '', time: '' };
    }
  };

export const convertDateForApi = (datePart, timePart) => {
    if (!datePart && !timePart) return "";

    return new Date(`${datePart}T${timePart}`).toISOString();
}

export const createTodayDateTimeAtHour = (hour) => {
  const now = new Date();
  const dt = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    hour, 0, 0
  ));
  return dt.toISOString();
}
